@if (isLoading() && items().length === 0) {
  @for (item of [1, 2, 3]; track item) {
    <app-loading-skeleton
      class="w-[150px] h-[26px]"
      viewBox="0 0 150 26"
      [preserveAspectRatio]="false"
      backgroundTextClass="text-background-fixed"
    >
      <svg:rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
    </app-loading-skeleton>
  }
} @else if (items().length === 0) {
  <p class="text-xs text-foreground-primary-40 px-1 py-2">{{ 'ai-assistant.no-previous-chats' | translate }}</p>
} @else {
  @for (item of items(); track item.id) {
    <button
      type="button"
      class="shrink-0 text-left py-1 px-2 text-xs overflow-hidden text-ellipsis whitespace-nowrap bg-[#EDEFF700] transition-colors rounded-radius-tertiary"
      [ngClass]="{
        '[&&]:bg-action-secondary-18 dark:[&&]:bg-background-main [&&]:text-action-secondary dark:[&&]:text-action-secondary-text':
          item.isActive,
      }"
      (click)="onSelect(item.id)"
    >
      {{ item.title }}
    </button>
  }
  @if (loadingMore()) {
    <app-loading-skeleton
      class="w-[150px] h-[26px]"
      viewBox="0 0 150 26"
      [preserveAspectRatio]="false"
      backgroundTextClass="text-background-fixed"
    >
      <svg:rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
    </app-loading-skeleton>
  }
}
